import { FC } from 'react';

interface Props {
  color?: string;
  className?: string;
  size?: 'medium';
}

const FaceAlienSvg: FC<Props> = ({ className, color, size }) => {
  switch (size) {
    case 'medium':
      return (
        <svg
          className={className}
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill={color ?? 'currentColor'}
          xmlns='http://www.w3.org/2000/svg'>
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M16.9046 17.9612C19.0238 16.0963 20.7 13.5486 20.7 10.5C20.7 8.32407 19.936 6.58507 18.581 5.37268C17.2078 4.14403 15.0494 3.3 12 3.3C8.95064 3.3 6.79218 4.14403 5.41898 5.37268C4.06396 6.58507 3.3 8.32407 3.3 10.5C3.3 13.5486 4.97618 16.0963 7.09538 17.9612C8.14444 18.8844 9.25417 19.5944 10.2082 20.0663C10.6847 20.302 11.1037 20.469 11.4394 20.5738C11.6066 20.626 11.7422 20.6594 11.8457 20.679C11.9532 20.6993 12.0014 20.7 12 20.7C11.9999 20.7 12 20.7 12.0002 20.7C12.0035 20.6999 12.0521 20.6983 12.1543 20.679C12.2578 20.6594 12.3934 20.626 12.5606 20.5738C12.8963 20.469 13.3153 20.302 13.7918 20.0663C14.7458 19.5944 15.8556 18.8844 16.9046 17.9612ZM12 22.5C14.25 22.5 22.5 18 22.5 10.5C22.5 5.25 18.75 1.5 12 1.5C5.25 1.5 1.5 5.25 1.5 10.5C1.5 18 9.75 22.5 12 22.5ZM13.875 14.875C13.3227 14.875 12.875 14.4273 12.875 13.875C12.875 12.6476 13.3763 11.6168 14.2134 10.9085C15.0339 10.2142 16.1194 9.875 17.25 9.875C17.8023 9.875 18.25 10.3227 18.25 10.875C18.25 12.1024 17.7487 13.1332 16.9116 13.8415C16.0911 14.5358 15.0056 14.875 13.875 14.875ZM11.125 13.875C11.125 14.4273 10.6773 14.875 10.125 14.875C8.99436 14.875 7.90893 14.5358 7.08843 13.8415C6.2513 13.1332 5.75 12.1024 5.75 10.875C5.75 10.3227 6.19771 9.875 6.75 9.875C7.88064 9.875 8.96607 10.2142 9.78657 10.9085C10.6237 11.6168 11.125 12.6476 11.125 13.875Z'
            fill={color ?? 'currentColor'}
          />
        </svg>
      );
    default:
      return (
        <svg
          className={className}
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill={color ?? 'currentColor'}
          xmlns='http://www.w3.org/2000/svg'>
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M10.8734 11.5237C12.2113 10.3463 13.2 8.79859 13.2 7C13.2 5.69907 12.7485 4.71007 11.9873 4.02893C11.2078 3.33153 9.92436 2.8 8 2.8C6.07564 2.8 4.79218 3.33153 4.01273 4.02893C3.25146 4.71007 2.8 5.69907 2.8 7C2.8 8.79859 3.78868 10.3463 5.12663 11.5237C5.78507 12.1031 6.48073 12.5475 7.07147 12.8397C7.5898 13.0961 7.89686 13.1717 7.98164 13.1926L8 13.1972L8.01836 13.1926C8.10314 13.1717 8.4102 13.0961 8.92852 12.8397C9.51927 12.5475 10.2149 12.1031 10.8734 11.5237ZM8 15C9.5 15 15 12 15 7C15 3.5 12.5 1 8 1C3.5 1 1 3.5 1 7C1 12 6.5 15 8 15ZM9.25 10.25C8.69771 10.25 8.25 9.80228 8.25 9.25C8.25 8.33508 8.6263 7.55433 9.2603 7.01786C9.87768 6.49547 10.6819 6.25 11.5 6.25C12.0523 6.25 12.5 6.69771 12.5 7.25C12.5 8.16492 12.1237 8.94566 11.4897 9.48213C10.8723 10.0045 10.0681 10.25 9.25 10.25ZM7.75 9.25C7.75 9.80228 7.30228 10.25 6.75 10.25C5.93186 10.25 5.12768 10.0045 4.51031 9.48213C3.8763 8.94566 3.5 8.16492 3.5 7.25C3.5 6.69771 3.94771 6.25 4.5 6.25C5.31814 6.25 6.12232 6.49547 6.73969 7.01786C7.3737 7.55433 7.75 8.33508 7.75 9.25Z'
            fill={color ?? 'currentColor'}
          />
        </svg>
      );
  }
};

export default FaceAlienSvg;
